import { Icon, IconProps } from '@elkaso-app/web-design';

export const DownArrowIcon = (props: IconProps) => {
  return (
    <Icon width='24px' height='24px' viewBox='0 0 24 24' fill='#E03E52' {...props}>
      <path d='M15 5L9 5L9 11L5 11L12 18L19 11L15 11L15 5Z' fill='inherit' />
    </Icon>
  );
};
